import * as React from 'react';
import Table from './Table';
import TableHead from '../Components/TableHead';

interface Props {
  cryptos: any;
  coinByCmcRank: any;
  allData: any;
  categoryCrypto: any;
  trending: any;
  coinNumber: any;
  mostVisited: any;
  gainersLosers: any;
  loading: boolean;
  isInWatchList: any;
}


const BoxTable = ({ cryptos, coinByCmcRank, allData, categoryCrypto, trending, coinNumber, mostVisited, gainersLosers, loading, isInWatchList } : Props) => {

  return (
    <table className="box-table">
      <TableHead />
      <tbody>
        {categoryCrypto === true && cryptos !== undefined &&
          Object.values(cryptos).map((line: any, index: any) => {
            const id = line.id;
            const rank = line.cmcRank;
            const name = line.name;
            const symbol = line.symbol;
            const price = JSON.parse(line.quote).USD.price;
            const percent_change_24h = JSON.parse(line.quote).USD.percent_change_24h;
            const percent_change_7d = JSON.parse(line.quote).USD.percent_change_7d;
            const fully_diluted_market_cap = JSON.parse(line.quote).USD.fully_diluted_market_cap;
            const market_cap_dominance = JSON.parse(line.quote).USD.market_cap_dominance;
            const marketCap = JSON.parse(line.quote).USD.market_cap;
            const volume_24h = JSON.parse(line.quote).USD.volume_24h;
            const circulating_supply = line.circulatingSupply;
            const max_supply = line.maxSupply;
            const total_supply = line.totalSupply;
            const coinPage = "/currencies/";
            const cryptoIndex = index + coinNumber;
            const quoteHistorical = JSON.parse(line.quotesHistorical)
            return (
              coinByCmcRank !== undefined && Object.values(coinByCmcRank).map((line: any, index: any) => {
                const metaId = line.id;
                if (id === metaId) {
                  const img = line.logo;

                  const TableProps = {
                    id, name, symbol, price, percent_change_24h, percent_change_7d, fully_diluted_market_cap, market_cap_dominance,
                    marketCap, volume_24h, allData, quoteHistorical, circulating_supply, max_supply, total_supply, coinPage, cryptoIndex, trending,
                    mostVisited, gainersLosers, coinByCmcRank, img, index, loading, rank, isInWatchList
                  }

                  return (
                    <Table key={index} {...TableProps} />
                  );
                }
              })
            );
          })
        }
        {categoryCrypto === false && cryptos !== undefined &&
          Object.values(cryptos).map((line: any, index: any) => {
            const id = line.id;
            const rank = line.cmcRank;
            const name = line.name;
            const symbol = line.symbol;
            const price = JSON.parse(line.quote).USD.price;
            const percent_change_24h = JSON.parse(line.quote).USD.percent_change_24h;
            const percent_change_7d = JSON.parse(line.quote).USD.percent_change_7d;
            const fully_diluted_market_cap = JSON.parse(line.quote).USD.fully_diluted_market_cap;
            const market_cap_dominance = JSON.parse(line.quote).USD.market_cap_dominance;
            const marketCap = JSON.parse(line.quote).USD.market_cap;
            const volume_24h = JSON.parse(line.quote).USD.volume_24h;
            const circulating_supply = line.circulatingSupply;
            const max_supply = line.maxSupply;
            const total_supply = line.totalSupply;
            const coinPage = "/currencies/";
            const cryptoIndex = index + coinNumber;
            const quoteHistorical = JSON.parse(line.quotesHistorical)
            return (
              coinByCmcRank !== undefined && Object.values(allData).map((line: any, index: any) => {
                const metaId = line.id;
                if (id === metaId) {
                  const img = line.logo;

                  const TableProps = {
                    id, allData, name, symbol, price, percent_change_24h, percent_change_7d, fully_diluted_market_cap, market_cap_dominance,
                    marketCap, volume_24h, circulating_supply, quoteHistorical, max_supply, total_supply, coinPage, cryptoIndex, trending,
                    mostVisited, gainersLosers, coinByCmcRank, img, index, loading, rank, isInWatchList
                  }

                  return (
                    <Table key={index} {...TableProps} />
                  );
                }
              })
            );
          })
        }
      </tbody>
    </table>
  )
}

export default BoxTable;